import {
  Dialog,
  DialogButtons,
  DialogContent,
  DialogMessageBox,
  DialogTitle,
} from '@verantos-dev/shared-components';

import { useAdDownloadModal } from '../hooks/useAdDownloadModal';
import type { AdDownloadModalProps } from '../types';

const DIALOG_PAPER_SX = { width: 600, maxHeight: '80%', margin: 0 } as const;

export const AdDownloadModal = ({ onClose }: AdDownloadModalProps) => {
  const {
    title,
    loadingTitle,
    loadingText,
    errorTitle,
    errorText,
    retryButtonLabel,
    isSubmitting,
    submittingError,
    onRetry,
  } = useAdDownloadModal({ onClose });

  const inError = !!submittingError && !isSubmitting;

  // A download is non-destructive, so the dialog is always dismissible — closing
  // mid-fetch just hides the progress UI (any in-flight save still completes).
  return (
    <Dialog
      id="adDownloadModal"
      open
      PaperProps={{ sx: DIALOG_PAPER_SX }}
      fullWidth
      maxWidth="lg"
      onClose={onClose}
    >
      <DialogTitle id="ad-download-modal-title" showClose onClose={onClose}>
        {title}
      </DialogTitle>
      <DialogContent>
        {inError ? (
          <DialogMessageBox
            id="ad-download-modal-error"
            title={errorTitle}
            type="error"
            text={errorText}
          />
        ) : (
          <DialogMessageBox
            id="ad-download-modal-loading"
            title={loadingTitle}
            type="loading"
            text={loadingText}
          />
        )}
      </DialogContent>
      {inError && (
        <DialogButtons
          id="ad-download-modal-buttons"
          saveButton={{ label: retryButtonLabel, onClick: onRetry }}
        />
      )}
    </Dialog>
  );
};
